'use client';

import { useContext, useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { getLaunchDarklyContext } from 'src/lib/launchdarkly-context';
import { AuthContext } from 'src/context/auth-context/auth-context';

const useLaunchDarklyIdentify = (): void => {
	const [userDetails] = useContext(AuthContext);
	const ldClient = useLDClient();

	useEffect(() => {
		if (!ldClient || !userDetails?.property_manager_id) return;

		const context = getLaunchDarklyContext(userDetails);
		if (JSON.stringify(ldClient.getContext()) === JSON.stringify(context))
			return;

		if (context)
			void ldClient.identify(context).catch((error) => {
				// biome-ignore lint/suspicious/noConsole: necessary logging
				console.error('Failed to identify LaunchDarkly context:', error);
			});
	}, [ldClient, userDetails]);
};

export default useLaunchDarklyIdentify;
